import React, {useState, useEffect} from 'react';
import styles from './styles';
import {getThreadsByPatientId, createNewThread} from '../Hooks';
import Portal from '../Shared/Portal';


const ConsoleMessagePortal = props => {
  const [thread, setThread] = useState(null);
  const {user, nct, apiUrl, headers} = props;
  const query = {
    id: props.patientId,
    nct
  }
  useEffect(() => {
    getThreadsByPatientId(
      query,
      res => {
        if (!res.data[0]) createNewThread({userId: props.patientId, nct, subject: 'init', message: '', instance: 'STANFORD'},
          res => {
            console.log(res)
            setThread(res.data);
          },
          err => {
            console.error(err);
            setThread(false);
          },
          apiUrl, headers)
        else setThread(res.data[0]);
      },
      err => {
        console.error(err);
        setThread(false)
      },
      props.apiUrl,
      props.headers
    )
  }, []);

  // test
  // if (thread) {
  //   console.log(thread);
  // }

  return(
    <div style={styles.container}>
      {thread === false && // errored
        <div style={styles.errorMessage}>
          <span>Something went wrong while fetching the message thread.</span>
        </div>
      }
      {thread !== null && // ready
        <Portal
          user={props.user}
          nct={props.nct}
          patientId={props.patientId}
          instance={props.instance}
          apiUrl={props.apiUrl}
          headers={props.headers}
          thread={thread}
        />
      }
    </div>
  );
}


export default ConsoleMessagePortal;
